import {isString} from "lodash"

import {MIN_SEARCH_CHARACTERS} from "../../constants/search"

export const isSearchTermValid = (searchTerm: unknown, enforceMinChars = true) =>
  isString(searchTerm) && (searchTerm.length >= MIN_SEARCH_CHARACTERS || !enforceMinChars)
